import React from 'react';
import { IIconProps } from './utils';

export const ChevronRight = ({
  fill = 'currentColor', height = 21, width = 21, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.25 22.5L17.8661 15.8839C18.3543 15.3957 18.3543 14.6043 17.8661 14.1161L11.25 7.5"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
